<template>
  <div class="procurementBidding wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-tree-table">
      <sliderTree :data="data"></sliderTree>
      <div class="ccui-app-container">
        <div
          class="ccui-advanced-search-wrapper ccui-clearfix"
          v-if="!isShowDetail"
        >
          <div class="ccui-search-wrapper">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini"
                >列表页面</el-button
              >
            </div>
          </div>
          <div class="dic-content">
            <el-form
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-form-item label="发布时间：">
                <el-input
                  v-model="formInline.time"
                  placeholder="请选择发布时间"
                ></el-input>
              </el-form-item>
              <el-form-item label="标题：">
                <el-input
                  v-model="formInline.title"
                  placeholder="请输入标题"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSeach">搜索</el-button>
                <el-button type="default-mini" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
            <!-- <ul>
              <li
                class="detail-title"
                v-for="(item, index) in dicArr"
                :key="index"
                @click="showDetail(item.faqId)"
              >
                <span :title="item.faqName"
                  ><span class="doct">.</span>{{ item.faqName }}</span
                >
                <span>{{ item.time }}</span>
              </li>
            </ul> -->
            <!-- <el-table :data="dicArr" border style="width: 100%">
              <el-table-column type="index" label="序号" width="50">
              </el-table-column>
              <el-table-column prop="faqName" label="标题"></el-table-column>
              <el-table-column prop="time" label="发布时间" width="100">
              </el-table-column>
            </el-table> -->
            <div class="dashboard-message">
              <el-table
                :data="dicArr"
                border
                style="width: 100%"
                @row-click="jumpToDetail"
              >
                <el-table-column
                  prop="number"
                  type="index"
                  label="序号"
                  width="48"
                />
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="faqName"
                  label="标题"
                />
                <el-table-column prop="time" width="100" label="发布时间" />
              </el-table>
            </div>
          </div>
          <div class="table-footer" style="height: 30px; margin-top: 20px">
            <div class="ccui-table-footer">
              <div id="ccui-paging">
                <el-pagination
                  :total="total"
                  :page-size="pageSizeCode"
                  :current-page="pageNoCode"
                  prev-text="< 上一页"
                  next-text="下一页 >"
                  background
                  :pagesize="pagesize"
                  layout="total, sizes, prev, pager, next, jumper"
                  popper-class="ccui-paging-page-size-popper"
                  @prev-click="handlePrev"
                  @next-click="handleNext"
                  @size-change="handleSizeChange"
                  @addCurrentPage="internalCurrentPage"
                  @current-change="handleCurrentChange"
                />
                <el-button
                  class="ccui-pagination-btn"
                  size="mini"
                  type="default"
                  @click="handleGoPage"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="ccui-advanced-search-wrapper ccui-clearfix"
          v-if="isShowDetail"
        >
          <div class="dic-view">
            <div class="title-box">
              <span class="content-title" :title="faqProblemBO.faqName">
                {{ faqProblemBO.faqName }}
              </span>
            </div>
            <div class="little-title">
              <span>来源： {{ faqProblemBO.publishTime }}</span>
              <span>作责 {{ faqProblemBO.readingCnt }}</span>
              <span>发布时间 {{ faqProblemBO.publishUser }}</span>
            </div>
            <div class="content-detail" v-html="faqProblemBO.textContent"></div>
          </div>
        </div>
        <div class="content-text" v-if="dicArr.length == 0">
          <!-- <img
            src="../../../assets/images/content_null.png"
            class="content-null-image"
            alt
          /> -->
          <p class="content-null-text">暂无相关数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import sliderTree from "@/app/shop/components/slideTree.vue";
export default {
  name: "procurementBidding",
  components: {
    baseBreadCrumb,
    sliderTree
  },
  data() {
    return {
      currBreadCrumb: [{ title: "采购招标" }, { title: "更多 >" }],
      data: [
        {
          label: "采购招标",
          children: [
            {
              label: "采购公告",
              children: []
            },
            {
              label: "评标公示",
              children: []
            },
            {
              label: "竞价公告",
              children: []
            }
          ]
        },
        {
          label: "市场动态",
          children: [
            {
              label: "采购公告",
              children: []
            },
            {
              label: "评标公示",
              children: []
            },
            {
              label: "竞价公告",
              children: []
            }
          ]
        },
        {
          label: "规章制度",
          children: [
            {
              label: "采购公告",
              children: []
            },
            {
              label: "评标公示",
              children: []
            },
            {
              label: "竞价公告",
              children: []
            }
          ]
        },
        {
          label: "集中采购",
          children: [
            {
              label: "采购公告",
              children: []
            },
            {
              label: "评标公示",
              children: []
            },
            {
              label: "竞价公告",
              children: []
            }
          ]
        },
        {
          label: "管理体系",
          children: [
            {
              label: "采购公告",
              children: []
            },
            {
              label: "评标公示",
              children: []
            },
            {
              label: "竞价公告",
              children: []
            }
          ]
        },
        {
          label: "交流论坛",
          children: [
            {
              label: "采购公告",
              children: []
            },
            {
              label: "评标公示",
              children: []
            },
            {
              label: "竞价公告",
              children: []
            }
          ]
        },
        {
          label: "监督反馈",
          children: [
            {
              label: "采购公告",
              children: []
            },
            {
              label: "评标公示",
              children: []
            },
            {
              label: "竞价公告",
              children: []
            }
          ]
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      },
      dicArr: [
        { faqId: "1", faqName: "如何修改登录密码？", time: "2021-09-30" },
        { faqId: "2", faqName: "如何验证/绑定手机？", time: "2021-09-30" },
        { faqId: "3", faqName: "如何提高账户安全等级？", time: "2021-09-30" },
        { faqId: "4", faqName: "如何修改登录密码？", time: "2021-09-30" },
        { faqId: "5", faqName: "如何验证/绑定手机？", time: "2021-09-30" },
        { faqId: "7", faqName: "如何提高账户安全等级？", time: "2021-09-30" },
        { faqId: "8", faqName: "如何修改登录密码？", time: "2021-09-30" },
        { faqId: "9", faqName: "如何验证/绑定手机？", time: "2021-09-30" },
        { faqId: "10", faqName: "如何提高账户安全等级？", time: "2021-09-30" },
        { faqId: "11", faqName: "如何修改登录密码？", time: "2021-09-30" },
        { faqId: "11", faqName: "如何验证/绑定手机？", time: "2021-09-30" },
        { faqId: "12", faqName: "如何提高账户安全等级？", time: "2021-09-30" },
        { faqId: "13", faqName: "如何修改登录密码？", time: "2021-09-30" },
        { faqId: "14", faqName: "如何验证/绑定手机？", time: "2021-09-30" },
        { faqId: "15", faqName: "如何提高账户安全等级？", time: "2021-09-30" },
        { faqId: "16", faqName: "如何提高账户安全等级？", time: "2021-09-30" },
        { faqId: "17", faqName: "如何提高账户安全等级？", time: "2021-09-30" },
        { faqId: "18", faqName: "如何提高账户安全等级？", time: "2021-09-30" }
      ],
      formInline: {
        time: "",
        title: ""
      },
      isShowDetail: false,
      pageSizeCode: 20,
      pageNoCode: 1,
      total: 1000,
      pagesize: [10, 20, 50, 100, 200, 500],

      faqProblemBO: {
        faqName: "11",
        publishTime: "11",
        readingCnt: "11",
        publishUser: "11",
        textContent: "11"
      }
    };
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    internalCurrentPage(val) {
      val = 10;
      console.log(`当前22页: ${val}`);
    },
    handlePrev() {},
    handleNext() {},
    handleGoPage() {
      console.log(111);
    },
    showDetail(id) {
      this.isShowDetail = true;
    },
    onSeach() {},
    onReset() {
      this.formInline.time = "";
      this.formInline.title = "";
    },
    jumpToDetail(row, col, e) {
      this.isShowDetail = true;
      this.faqProblemBO.faqName = row.faqName;
      this.faqProblemBO.publishTime = row.time;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/config/styles/question-edit.scss";
/deep/ .el-tree-node__content {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

/* 改变被点击节点背景颜色，字体颜色 */
/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: #f8f8f8 !important;
  color: #4a9de7 !important;
}
/*节点失焦时的背景颜色*/
/deep/
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #f8f8f8 !important;
  color: #4a9de7 !important;
}
.ccui-tree-table .ccui-tree-wrapper /deep/ .el-tree-node__content span {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  height: 20px;
}
/deep/ #ccui-paging .ccui-pagination-btn {
  display: block !important;
  margin-left: 5px;
  border-radius: 0;
}
/deep/ .detail-title {
  display: flex;
  justify-content: space-between;
  span:last-child {
    width: 82px;
    height: 20px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999990;
    letter-spacing: 0;
    font-weight: 400;
  }
}
.ccui-tree-table .ccui-app-container {
  overflow: hidden;
}
.el-form--inline {
  padding: 20px 30px;
  .el-input {
    width: 220px;
  }
  .el-form-item:first-of-type {
    margin-right: 40px;
  }
  .el-form-item:last-of-type {
    display: block;
    margin-bottom: 0px;
    text-align: center;
  }
}
</style>
